import React from "react";
import classNames from "classnames";
import {
  ButtonContentDirection,
  ButtonCustomCSS,
  ButtonShape,
  ButtonSize,
  ButtonVariant,
} from "./button-helper";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * Button variant
   */
  variant?: ButtonVariant;
  /**
   * Extend classnames
   */
  extendClasses?: string;
  /**
   * Icon component
   */
  icon?: React.ReactNode;
  /**
   * Button content
   */
  children: React.ReactNode;
  /**
   * Content direction
   */
  contentDirection?: ButtonContentDirection;
  /**
   * Shape of button
   */
  shape?: ButtonShape;
  /**
   * Loading
   */
  loading?: boolean;
  /**
   * Loading component
   */
  loadingIndicator?: React.ReactNode;
  /**
   * Sizing
   */
  size?: ButtonSize;
  /**
   * Primary color
   */
  primaryColor?: string;
  /**
   * Primary color hovered
   */
  hoveredPrimaryColor?: string;
}

const Button: React.FC<Props> = ({
  variant = "default",
  extendClasses,
  icon,
  children,
  contentDirection,
  shape,
  loading,
  loadingIndicator,
  size,
  primaryColor = "#f05b28",
  hoveredPrimaryColor = "#ea511e",
  disabled,
  ...props
}) => {
  return (
    <button
      {...props}
      disabled={disabled}
      className={classNames({
        [extendClasses as string]: !!extendClasses,
        tfcbtn: true,
        [`tfcbtn-${variant}`]: true,
        [`tfcbtn-${contentDirection}`]: !!contentDirection,
        [`tfcbtn-${shape}`]: !!shape,
        [`tfcbtn-loading`]: loading,
        [`tfcbtn-${size}`]: !!size,
      })}
      style={
        {
          "--primary-color": primaryColor,
          "--primary-color-hovered": hoveredPrimaryColor,
        } as ButtonCustomCSS
      }
    >
      {loading ? (
        loadingIndicator
      ) : (
        <>
          {children}
          {icon && <span className="tfcbtn-icon">{icon}</span>}
        </>
      )}
    </button>
  );
};

export default Button;
